// Vuex Auth module (namespaced) with login/logout and auto-restore
import { api } from '../../services/api'

const STORAGE_KEY = 'auth'

const state = () => ({
  user: null,
  role: null,
  token: null,
  isAuthenticated: false
})

const getters = {
  getUser: (s) => s.user,
  getRole: (s) => s.role,
  isLoggedIn: (s) => s.isAuthenticated
}

const mutations = {
  SET_AUTH(state, payload) {
    state.user = payload.user || null
    state.role = payload.role || null
    state.token = payload.token || null
    state.isAuthenticated = !!(payload.role || payload.token || payload.user)
  },
  LOGOUT(state) {
    state.user = null
    state.role = null
    state.token = null
    state.isAuthenticated = false
  }
}

const actions = {
  async login({ commit }, { email, password, role }) {
    // Call backend login
    const res = await api.post('admin/login', { email, password, role })
    // Backend returns: { message, role }
    const session = {
      user: { email },
      role: res.role || role,
      token: null
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session))
    commit('SET_AUTH', session)
    return res
  },
  logout({ commit }) {
    localStorage.removeItem(STORAGE_KEY)
    commit('LOGOUT')
  },
  initialize({ commit }) {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) {
      try {
        const session = JSON.parse(raw)
        commit('SET_AUTH', session)
      } catch (_) {
        // corrupted storage, clear
        localStorage.removeItem(STORAGE_KEY)
        commit('LOGOUT')
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
